import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import ResourceGuideGrid from '../../../features/common/resource-guide-grid/components/ResourceGuideGrid';

export default function ResourceGuidesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Resource Guides')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ResourceGuideGrid />
			</div>
		</React.Fragment>
	)
} 
